import { render, staticRenderFns } from "./SBPrescriptionsAddEdit.vue?vue&type=template&id=1bb5e700"
import script from "./SBPrescriptionsAddEdit.vue?vue&type=script&lang=js"
export * from "./SBPrescriptionsAddEdit.vue?vue&type=script&lang=js"
import style0 from "./SBPrescriptionsAddEdit.vue?vue&type=style&index=0&id=1bb5e700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports